// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/registration/legal_entities/firstparty/v1/list_legal_entities.proto

/* oxlint-disable */
import { ApiLegalEntity } from "./legal_entity";

/** Request message for listing legal entities */
export interface ApiListLegalEntitiesRequest {
  /** The ID of the organization to retrieve legal entities for */
  readonly organizationId: string;
}

/** Response message for listing legal entities */
export interface ApiListLegalEntitiesResponse {
  /** List of legal entities for the organization */
  readonly data: readonly ApiLegalEntity[];
}

/** Error codes for ListLegalEntities operation */
export interface ApiListLegalEntitiesErrors {
}

/** Not found error codes */
export const ApiListLegalEntitiesErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED - Legal entities not found or unauthorized */
  NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED: "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED",
} as const;

export type ApiListLegalEntitiesErrorsNotFoundError =
  typeof ApiListLegalEntitiesErrorsNotFoundError[keyof typeof ApiListLegalEntitiesErrorsNotFoundError];

export namespace ApiListLegalEntitiesErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiListLegalEntitiesErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED =
    typeof ApiListLegalEntitiesErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
}

export function apiListLegalEntitiesErrorsNotFoundErrorFromJSON(object: any): ApiListLegalEntitiesErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiListLegalEntitiesErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED":
      return ApiListLegalEntitiesErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
    default:
      return ApiListLegalEntitiesErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiListLegalEntitiesErrorsNotFoundErrorToJSON(object: ApiListLegalEntitiesErrorsNotFoundError): string {
  switch (object) {
    case ApiListLegalEntitiesErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiListLegalEntitiesErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED:
      return "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

export const ApiListLegalEntitiesRequest: MessageFns<ApiListLegalEntitiesRequest> = {
  fromJSON(object: any): ApiListLegalEntitiesRequest {
    return { organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : "" };
  },

  toJSON(message: ApiListLegalEntitiesRequest): unknown {
    const obj: any = {};
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    return obj;
  },
};

export const ApiListLegalEntitiesResponse: MessageFns<ApiListLegalEntitiesResponse> = {
  fromJSON(object: any): ApiListLegalEntitiesResponse {
    return {
      data: globalThis.Array.isArray(object?.data)
        ? object.data.map((e: any) => ApiLegalEntity.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiListLegalEntitiesResponse): unknown {
    const obj: any = {};
    if (message.data?.length) {
      obj.data = message.data.map((e) => ApiLegalEntity.toJSON(e));
    }
    return obj;
  },
};

export const ApiListLegalEntitiesErrors: MessageFns<ApiListLegalEntitiesErrors> = {
  fromJSON(_: any): ApiListLegalEntitiesErrors {
    return {};
  },

  toJSON(_: ApiListLegalEntitiesErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
